
export const pricingPlans = [
  {
    name: "Posit",
    price: "Free",
    annualPrice: "Free",
    priceId: "price_free", // Free tier - no actual Stripe price needed
    annualPriceId: "price_free",
    features: [
      "Posit+ two-week trial",
      "AI Capture: Quickly capture and structure your knowledge, experience, and insights with AI-driven prompts",
      "1 Posit: Store and make unlimited updates to your Posit so your team can access \"you\" anytime",
      "Unlimited Searches: Anyone with the link can access your second \"you\"",
    ],
  },
  {
    name: "Posit Plus",
    price: "8",
    annualPrice: "45",
    // Updated with correct Stripe price IDs
    priceId: "price_1Qr871EMzQsdB9AdMlglAgMe", // $8.00/month recurring
    annualPriceId: "price_1Qr8WmEMzQsdB9AdRTFia7qK", // $45.00/year recurring
    features: [
      "Everything included with your free Posit",
      "Privacy: Share with select team members or keep it to yourself",
      "View Activity: View a live feed of Posit questions",
      "Notifications: Explore moments where your Posit needed more information to complete its response",
      "Analytics: Track engagement with your Posit (coming soon)",
      "Multiple Posits: Create team and project specific Posits (coming soon)",
      "Affiliate Program: Earn 5% commission on referrals for Posit+ subscriptions and paid Posits",
      "24/7 Email Support: There when you need us most",
    ],
  },
];

// Export individual price IDs for easy import
export const STRIPE_PRICE_IDS = {
  MONTHLY: "price_1Qr871EMzQsdB9AdMlglAgMe",
  ANNUAL: "price_1Qr8WmEMzQsdB9AdRTFia7qK",
  FREE: "price_free"
} as const;
